import { Typography } from '@mui/material';
import React from 'react';

import { colors, theme } from '../theme/theme';

interface CommonStatusChipProps {
    label: string;
    chipBgColor?: string;
    chipTextColor?: string;
    chipBorderColor?: string;
    chipFontSize?: number;
    chipFontWeight?: number;
    chipPadding?: string;
    chipBorderRadius?: number;
    sx?: Record<string, unknown>;
}

const CommonStatusChip: React.FC<CommonStatusChipProps> = ({
    label,
    chipBgColor = colors.greyPreset[80],
    chipTextColor = colors.fullWhite,
    chipBorderColor = chipBgColor,
    chipFontSize = { ...theme.typography.subtitle2 },
    chipFontWeight = 600,
    chipPadding = '4px 8px',
    chipBorderRadius = 6,
    sx,
}) => {
    return (
        <Typography
            sx={{
                backgroundColor: chipBgColor,
                color: chipTextColor,
                fontSize: chipFontSize,
                fontWeight: chipFontWeight,
                borderRadius: chipBorderRadius,
                padding: chipPadding,
                display: 'inline-block',
                border: chipBorderColor ? `1px solid ${chipBorderColor}` : 'none',
                lineHeight: 'normal',
                textAlign: 'center',
                width: 'fit-content',
                height: 'fit-content',
                ...sx,
            }}
        >
            {label}
        </Typography>
    );
};

export default CommonStatusChip;
